import $api from '../services';

export default {
    contact(params) {
        return $api.post('/contact', params);
    },
    subscribe(params) {
        return $api.post('/newsletter_subscribe', params);
    },
};
